import { Component, OnInit, Input,Output , EventEmitter } from "@angular/core";
@Component ({
    selector: 'round-chevron',
    template: `
    <button class="caret-button"
    [ngClass]="{ opened: isOpen }"
    (click)="toggle()">
<i class="icon icon-caret"></i>
</button>
`,
styleUrls : ['./roundchevron.component.scss']
})

export class RoundchevronComponent  {
  @Input() isOpen: boolean;
  @Output() click :  EventEmitter<any> = new EventEmitter();
     constructor () {

     }

     toggle() {
        // this.click.emit();
     }
}